module.exports = __webpack_public_path__ + "static/Apercu-Light-5448eeec20006402ff6045ad7456fb72.svg";